export default __webpack_public_path__ + "static/media/upload.361ea1af.gif";